<template>
  <div id="chart-wrap">
    <CButton color="warning" size="sm" @click="replaceData">変更</CButton>
    <apexchart  width="70%" height="400" type="bar" :options="chartOptions"
               :series="series"></apexchart>


<!--    <div class="legend" style="margin-top: 50px;">-->
<!--      &lt;!&ndash; <div class="pretty p-svg p-smooth"> &ndash;&gt;-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #BE1F05;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->

<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #F60003;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #F64E09;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #F9C308;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #FAFF09;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->

<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #C3FF28;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #5BFF27;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #2BFF87;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #31C0FF;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #274EC1;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->

<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #2701FF;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #8547FF;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #8500FF;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->
<!--      <div class="chart-regend"><div class="cart-regend-item" style="border:solid 4px #520053;"><label style="font-size: 0.7rem;">1.5</label></div></div>-->

<!--    </div>-->
<!--    <div :key="index" v-for="(colorData, index) in colorDataList" class="row mb-1">-->
<!--      <div v-bind:style="{ backgroundColor: colorData.color }">{{ colorData.color }}:</div>-->
<!--    </div>-->
  </div>


</template>

<script>
let colorList={
 // "0.25":"#BE1F05",
 // "0.5":"#F60003",
 // "0.75":"#F64E09",
 // "1.0":"#F9C308",
 // "1.25":"#FAFF09",
 // "1.5":"#C3FF28",
 // "1.75":"#5BFF27",
 // "2.0":"#2BFF87",
 // "2.5":"#31C0FF",
 // "3.0":"#274EC1",
 // "3.5":"#2701FF",
 // "4.0":"#8547FF",
 // "4.5":"#8500FF",
 // "5.0":"#520053",
  "0.25":"#DCDC80",
  "0.50":"#F0ED83",
  "0.75":"#98B54F",
  "1.00":"#66FF33",
  "1.25":"#00FF99",
  "1.50":"#00B050",
  "1.75":"#00B0B0",
  "2.00":"#3366CC",
  "2.50":"#0000FF",
  "3.00":"#9966FF",
  "3.50":"#9900FF",
  "4.00":"#FFC000",
  "4.50":"#FF962A",
  "5.00":"#FF9999",
}

let valueList=[
  "0.25",
  "0.5",
  "0.75",
  "1.0",
  "1.25",
  "1.5",
  "1.75",
  "2.0",
  "2.5",
  "3.0",
  "3.5",
  "4.0",
  "4.5",
  "5.0",
]



// let colorList=[
//   {v:0.25,color:"#BE1F05"}
//   ,{v:0.5,color:"#F60003"}
//   ,{v:0.75,color:"#F64E09"}
//   ,{v:1.0,color:"#F9C308"}
//   ,{v:1.25,color:"#FAFF09"}
//
//   ,{v:1.5 ,color:"#C3FF28"}
//   ,{v:1.75,color:"#5BFF27"}
//   ,{v:2.0 ,color:"#2BFF87"}
//   ,{v:2.5 ,color:"#31C0FF"}
//   ,{v:3.0 ,color:"#274EC1"}
//
//   ,{v:3.5,color:"#2701FF"}
//   ,{v:4.0,color:"#8547FF"}
//   ,{v:4.5,color:"#8500FF"}
//   ,{v:5.0,color:"#520053"}
// ]
import moment from "moment";

export default {
  name: "App",

  methods:{
    replaceData(){
      // this.series = this.getSeries();
      this.getSeries();
    },
    getSeries(){
      let list = [];
      // for(let i=0;i<7;i++){
      //   let data = []
      //   for(let j =0;j<7;j++){
      //     let value = valueList[Math.floor( Math.random() * valueList.length )]
      //     // let colorValue = Math.floor( Math.random() * this.colorDataList.length )
      //
      //     data.push({x: "2017-02-1"+j,y: Math.floor( Math.random() * 60*60*24 ),v:value});
      //   }
      //   list.push({
      //     name: (i+1).toString(),
      //     data: data
      //   });
      // }
      // console.log(JSON.stringify(list));
      // return list;
      // return [{"name":"1","data":[{"x":"2021-03-14","y":45183,"v":"4.50"},{"x":"2021-03-15","y":2410,"v":"1.25"},{"x":"2021-03-16","y":848,"v":"1.50"},{"x":"2021-03-17","y":17886,"v":"1.50"},{"x":"2021-03-18","y":35521,"v":"2.50"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"2","data":[{"x":"2021-03-14","y":132,"v":"1.50"},{"x":"2021-03-15","y":3619,"v":"2.00"},{"x":"2021-03-16","y":1047,"v":"9.99"},{"x":"2021-03-17","y":23005,"v":"9.99"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"3","data":[{"x":"2021-03-14","y":154,"v":"4.50"},{"x":"2021-03-15","y":3619,"v":"0.25"},{"x":"2021-03-16","y":1671,"v":"1.50"},{"x":"2021-03-17","y":171,"v":"1.50"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"4","data":[{"x":"2021-03-14","y":442,"v":"4.00"},{"x":"2021-03-15","y":63300,"v":"1.25"},{"x":"2021-03-16","y":17495,"v":"1.00"},{"x":"2021-03-17","y":243,"v":"1.00"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"5","data":[{"x":"2021-03-14","y":241,"v":"0.25"},{"x":"2021-03-15","y":223,"v":"5.00"},{"x":"2021-03-16","y":11352,"v":"9.99"},{"x":"2021-03-17","y":1025,"v":"1.50"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"6","data":[{"x":"2021-03-14","y":252,"v":"3.00"},{"x":"2021-03-15","y":143,"v":"1.75"},{"x":"2021-03-16","y":4176,"v":"1.50"},{"x":"2021-03-17","y":256,"v":"1.75"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"7","data":[{"x":"2021-03-14","y":144,"v":"1.25"},{"x":"2021-03-15","y":121,"v":"2.00"},{"x":"2021-03-16","y":46593,"v":"9.99"},{"x":"2021-03-17","y":704,"v":"2.50"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"8","data":[{"x":"2021-03-14","y":330,"v":"1.00"},{"x":"2021-03-15","y":198,"v":"5.00"},{"x":"2021-03-16","y":3218,"v":"1.50"},{"x":"2021-03-17","y":88,"v":"9.99"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"9","data":[{"x":"2021-03-14","y":253,"v":"1.25"},{"x":"2021-03-15","y":145,"v":"1.50"},{"x":"2021-03-16 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-17","y":43022,"v":"2.50"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"10","data":[{"x":"2021-03-14","y":121,"v":"4.00"},{"x":"2021-03-15","y":19,"v":"4.50"},{"x":"2021-03-16 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-17 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"11","data":[{"x":"2021-03-14","y":847,"v":"3.50"},{"x":"2021-03-15","y":22,"v":"2.50"},{"x":"2021-03-16 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-17 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]},{"name":"12","data":[{"x":"2021-03-14","y":219,"v":"0.25"},{"x":"2021-03-15","y":210,"v":"4.00"},{"x":"2021-03-16 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-17 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-18 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-19 00:00:00","y":0,"v":"0.00"},{"x":"2021-03-20 00:00:00","y":0,"v":"0.00"}]}];


      this.axios.get(`/api/measureValue/getOxGraphData/14/7/2021-03-14`)
          .then(response => {
            this.series = response.data.result;
            // console.log("this.series",JSON.stringify(this.series));
          }).catch(error => {
      })
          .finally(() => {
          });



    },
  },
  mounted(){
      // this.series = this.getSeries();
    this.getSeries();
  },
  data() {
    return {
      colorDataList:colorList,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 500,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          },animations: {
            enabled: false,
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke:{
          show:false,
          curve:'straight',
          width: 2,
          colors:["#000"]
        },
        // responsive: [{
        //   breakpoint: 480,
        //   options: {
        //     legend: {
        //       show:false,
        //       position: 'bottom',
        //       offsetX: -10,
        //       offsetY: 0
        //     }
        //   }
        // }],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        // colors: [function({ value, seriesIndex ,dataPointIndex, w }) {
        //   // console.log("color function",value,seriesIndex,dataPointIndex,
        //   // w.globals.initialSeries[seriesIndex].data[dataPointIndex].c,w);
        //   // console.log(w.globals.initialSeries[seriesIndex].data[dataPointIndex].c)
        //   // console.log(w.globals.initialSeries[seriesIndex].data[dataPointIndex].c);
        //   // return w.globals.initialSeries[seriesIndex].data[dataPointIndex].c;
        //   // return w.globals.initialSeries[seriesIndex].data[dataPointIndex].c;
        //   //"#009"系の色を返す
        //   return colorList[w.globals.initialSeries[seriesIndex].data[dataPointIndex].v];
        // }],
        xaxis: {
          type: "date",　//日以外
          // type: "datetime",　 //時間
          labels: {
            show: true,
            rotate: -20,
            format: 'yyyy/MM/dd', //日以外
            //format: 'yyyy/MM/dd HH:mm' 日
            /**
             * Allows users to apply a stom formatter function to xaxis labels.
             *
             * @param { String } value - The default value generated
             * @param { Number } timestamp - In a datetime series, this is the raw timestamp
             * @param { object } contains dateFormatter for datetime x-axis
             */
            formatter: function (value, timestamp, opts) {

              return moment(value).format("M/DD");
            }
          }
        },

        yaxis: {
          min: 0,
          max: 86400,//秒
          tickAmount: 24,//24時間
          labels:{
            show:true,
            formatter: function(val, index) {
              let hour = (val / 60 / 60);
              if(hour % 2 == 1){
                return (val / 60 / 60)+"h";
              }
              return "";
            }
          }
        },
        legend: {
          show:false,
        },
        fill: {
          opacity: 1
        }
      },
    }
  }
};
</script>
<style>
.chart-regend{
  position: relative;
  display: inline-block;
  margin-right: 0.5em;
  white-space: nowrap;
  line-height: 0.7;
  margin-top: 20px;
  margin: 0 auto;
}
.cart-regend-item{
  padding:5px 3px;
  border:solid 1px rgb(180, 179, 179);
  margin-top: 100px;
}
#chart-wrap {
  max-width: 800px;
  position: relative;
  margin: 35px auto;
}

#chart {
  padding-bottom: 30px;
  max-width: 800px;
}

.legend {
  max-width: 800px;
  left: 80px;
  bottom: 10px;
  position: absolute;
  text-align: right;
}

</style>
